import React from 'react';
import PropTypes from 'prop-types';
import { Column, TextInput } from '@pella/sash-framework';
import { RTA_ERRORS } from '../../../utilities/constants';
import { removePhoneNumberFormat } from '../../../utilities/functions';

const ContactInfoFields = ({ formLabels, formData, errors, handleChange, handleBlur, handleNumberChange }) => {
	return (
		<>
			<Column
				xs='12'
				sm='6'
			>
				<TextInput
					groupClass='mb-6'
					error={errors.firstname ? true : false}
					errorText={RTA_ERRORS.FIRSTNAME_REQUIRED}
					id='firstname'
					type='text'
					required
					aria-required='true'
					labelText={formLabels.first_name}
					value={formData.firstname}
					onChange={handleChange}
					onBlur={handleBlur}
					autoComplete='given-name'
				/>
			</Column>

			<Column
				xs='12'
				sm='6'
			>
				<TextInput
					groupClass='mb-6'
					error={errors.lastname ? true : false}
					errorText={RTA_ERRORS.LASTNAME_REQUIRED}
					id='lastname'
					type='text'
					required
					aria-required='true'
					labelText={formLabels.last_name}
					value={formData.lastname}
					onChange={handleChange}
					onBlur={handleBlur}
					autoComplete='family-name'
				/>
			</Column>

			<Column
				xs='12'
				sm='6'
			>
				<TextInput
					groupClass='mb-6'
					error={errors.email ? true : false}
					errorText={RTA_ERRORS.EMAIL_REQUIRED}
					id='email'
					type='text'
					required
					aria-required='true'
					onChange={handleChange}
					onBlur={handleBlur}
					labelText={formLabels.email}
					value={formData.email}
					autoComplete='email'
				/>
			</Column>

			<Column
				xs='12'
				sm='6'
			>
				<TextInput
					groupClass='mb-6'
					error={errors.phone ? true : false}
					errorText={RTA_ERRORS.PHONE_REQUIRED}
					id='phone'
					type='tel'
					format='(###) ###-####'
					allowEmptyFormatting
					onValueChange={(values) => handleNumberChange('phone', values.formattedValue)}
					autoComplete='on'
					required
					aria-required='true'
					labelText={formLabels.phone}
					value={formData.phone}
					onBlur={handleBlur}
					counter={`${removePhoneNumberFormat(formData.phone).length}/10`}
				/>
			</Column>
		</>
	);
};

ContactInfoFields.propTypes = {
	formLabels: PropTypes.object,
	formData: PropTypes.object,
	errors: PropTypes.object,
	handleChange: PropTypes.func,
	handleBlur: PropTypes.func,
	handleNumberChange: PropTypes.func,
};

export default ContactInfoFields;
